import { GET_ALL_DAILY_MORNING_PLANNER_REQUEST, GET_ALL_DAILY_MORNING_PLANNER_SUCCESS, GET_ALL_DAILY_MORNING_PLANNER_FAILURE } from "../actionTypes"

interface getAllDailyMorningPlannerListState {
    loading  : boolean,
    getAllDailyMorningPlanner : any,
    error : string
}

interface action {
    type : string
    payload : any
}

const initialState:getAllDailyMorningPlannerListState = {
    loading  : false,
    getAllDailyMorningPlanner : {},
    error : ""
}

export const getAllDailyMorningPlannerReducer = (state = initialState, action : action) => {
    switch(action.type){
        case GET_ALL_DAILY_MORNING_PLANNER_REQUEST : return {
            ...state,
            loading : true
        }
        case GET_ALL_DAILY_MORNING_PLANNER_SUCCESS : return {
            ...state,
            loading : false,
            getAllDailyMorningPlanner : action.payload,
            error : ""
        }
        case GET_ALL_DAILY_MORNING_PLANNER_FAILURE : return {
            ...state,
            loading : false,
            getAllDailyMorningPlanner : {},
            error : action.payload
        }
       
        default : return state
    }
}